document.addEventListener('DOMContentLoaded', () => {
    const staticContainer = document.querySelector('.shopify-product-form > div > div.w-full');
    if (!staticContainer) {
      return;
    }
  
    let currentPriceText = '';
    let discountedText = '';
    let isSyncing = false;
    let debounceTimer = null;
    let pendingSync = false;
    let wrapper = null;
    let wrapperObserver = null;
  
    const getAllPriceEls = () => [
      ...document.querySelectorAll('.appstle_one_time_price_wrapper .appstle_subscription_amount .dualprice'),
      ...document.querySelectorAll('.appstle_subscription_amount_wrapper .appstle_subscription_compare_amount .dualprice'),
      ...document.querySelectorAll('.appstle_subscription_amount_wrapper .appstle_subscription_amount')
    ];
  
    const addCustomPriceClass = () => {
      getAllPriceEls().forEach(el => el.classList.add('custom-price-updated'));
    };
  
    const removeCustomPriceClass = () => {
      getAllPriceEls().forEach(el => el.classList.remove('custom-price-updated'));
    };
  
    function finishSync() {
      isSyncing = false;
      pendingSync = false;
      if (wrapper && wrapperObserver) {
        wrapperObserver.observe(wrapper, { childList: true, subtree: true, characterData: true });
      }
    }
  
    function syncPrices() {
      pendingSync = false;
      clearTimeout(debounceTimer);
  
      isSyncing = true;
      if (wrapperObserver) {
        wrapperObserver.disconnect();
      }
  
      const checkedBundleRadio = staticContainer.querySelector('.rapi-bundles__bar input[type="radio"]:checked');
      if (!checkedBundleRadio) {
        finishSync();
        return;
      }
  
      document.querySelectorAll('.rapi-bundles__bar').forEach(el => el.classList.remove('rapi-bundles__bar--active'));
      const activeBar = checkedBundleRadio.closest('.rapi-bundles__bar');
      if (activeBar) {
        activeBar.classList.add('rapi-bundles__bar--active');
      }
  
      const priceDiv = activeBar.querySelector('.rapi-bundles__bar-price');
      const priceText = priceDiv?.textContent.trim();
      if (!priceText) {
        finishSync();
        return;
      }
      currentPriceText = priceText;
  
      const match = priceText.match(/([£$€])?(\d+(?:\.\d+)?)/);
      if (match) {
        const currency = match[1] || '';
        const base = parseFloat(match[2]);
        discountedText = `${currency}${(base * 0.95).toFixed(2)}`;
      }
  
      document.querySelectorAll(
        '.appstle_one_time_price_wrapper .appstle_subscription_amount .dualprice,' +
        '.appstle_subscription_amount_wrapper .appstle_subscription_compare_amount .dualprice'
      ).forEach(el => { el.textContent = currentPriceText; });
  
      document.querySelectorAll(
        '.appstle_subscription_amount_wrapper .appstle_subscription_amount'
      ).forEach(el => { el.textContent = discountedText; });
  
      addCustomPriceClass();
  
      finishSync();
    }
  
    function scheduleSync(triggerSource = 'unknown') {
      if (wrapperObserver) {
        wrapperObserver.disconnect();
      }
      if (pendingSync) {
        return;
      }
      pendingSync = true;
      removeCustomPriceClass();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncPrices, 100);
    }
  
    function observeSubscriptionWrapper() {
      wrapper = staticContainer.querySelector('.appstle_subscription_wrapper');
      if (!wrapper) {
        return;
      }
  
      wrapperObserver = new MutationObserver(records => {
        if (isSyncing) {
          return;
        }
        scheduleSync('mutationObserver');
      });
  
      wrapperObserver.observe(wrapper, { childList: true, subtree: true, characterData: true });
    }
  
    staticContainer.addEventListener('change', e => {
      const tgt = e.target;
      if (
        tgt.matches('input[type="radio"]:checked') &&
        (tgt.closest('.rapi-bundles__bar') || tgt.name === 'selling_plan')
      ) {
        scheduleSync('changeEvent-radio');
      }
      else if (tgt.matches('.rapi-bundles__bar-variant-select')) {
        scheduleSync('changeEvent-variantSelect');
      }
    });
  
    const outerMo = new MutationObserver((_, obs) => {
      const bundlesLoaded = !!staticContainer.querySelector('.rapi-bundle-content-0');
      const subWrapperLoaded = !!staticContainer.querySelector('.appstle_subscription_wrapper');
      if (bundlesLoaded && subWrapperLoaded) {
        syncPrices();
        observeSubscriptionWrapper();
        obs.disconnect();
      }
    });
  
    outerMo.observe(staticContainer, { childList: true, subtree: true });
});